import { ToastAlertVariants, type ToastPayload, type ToastWithoutID } from '../ToastContext';

export type MakeToastBuilderReturn = Record<ToastAlertVariants, (p?: ToastPayload) => void>;

type MakeToastBuilder = (
  cb: (p: ToastWithoutID) => void,
  base?: ToastPayload,
) => MakeToastBuilderReturn;

const createPayloadHelper = (
  type: ToastAlertVariants,
  ...sources: (ToastPayload | undefined)[]
): ToastWithoutID => ({
  type,
  ...sources.reduce(
    (acc, source) => ({ ...acc, ...source, config: { ...acc?.config, ...source?.config } }),
    {},
  ),
});

export const makeToastBuilder: MakeToastBuilder = (cb, base) => ({
  [ToastAlertVariants.success]: (p) => cb(createPayloadHelper(ToastAlertVariants.success, base, p)),
  [ToastAlertVariants.error]: (p) => cb(createPayloadHelper(ToastAlertVariants.error, base, p)),
  [ToastAlertVariants.info]: (p) => cb(createPayloadHelper(ToastAlertVariants.info, base, p)),
});
